import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { BsEnvelope, BsKey, BsPerson } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { hasRole } from "../../utils/roles";
import RoleBadge from "../role-badge/RoleBadge";
import { RoleCode } from "../users/store/slice";
import styles from "./profilePage.module.scss";
import { useCallback, useState } from "react";
import profilePageSlice from "./store/slice";
import { AppState } from "../../store";
import ConfirmModal from "../confirm-modal/ConfirmModal";

const ProfilePage = () => {
  const dispatch = useDispatch();

  const [deleteModalVisible, setDeleteModalVisible] = useState<boolean>(false);

  const profile = useSelector((state: AppState) => state.loginPage.profile);

  const toggleNotifications = useCallback(
    () => dispatch(profilePageSlice.actions.toggleNotifications()),
    [dispatch]
  );

  const deleteProfile = useCallback(
    () => dispatch(profilePageSlice.actions.deleteProfile()),
    [dispatch]
  );

  if (!profile) return null;

  return (
    <Container fluid>
      <Row>
        <Col />
        <Col lg={4}>
          <Card className={styles.card}>
            <Card.Body>
              <Card.Title>
                <BsPerson /> {profile.name}{" "}
                {profile.roles.map(({ name }, index) => (
                  <RoleBadge
                    key={index}
                    name={name}
                    className={styles.roleBadge}
                  />
                ))}
              </Card.Title>
              <hr />
              <Card.Text className={styles.data}>
                <span>
                  <BsEnvelope /> {profile.email}
                </span>
                <span>
                  <BsKey /> **************{" "}
                  {!hasRole(profile, RoleCode.Internal) && (
                    <Link to="/change-password">change</Link>
                  )}
                </span>
                <Form.Check
                  type="switch"
                  id="notifications-switch"
                  checked={!!profile.notifications_enabled}
                  onChange={toggleNotifications}
                  label="Send email notifications."
                />
              </Card.Text>

              <Button
                variant="danger"
                onClick={() => setDeleteModalVisible(true)}
                disabled={profile.is_girteka_user}
              >
                Delete account
              </Button>
            </Card.Body>
          </Card>

          {deleteModalVisible && (
            <ConfirmModal
              isVisible={true}
              question="Delete account?"
              onHide={() => setDeleteModalVisible(false)}
              onSubmit={deleteProfile}
              body={<span>Action is not reversable.</span>}
              submitText="Delete"
              submitVariant="danger"
            />
          )}
        </Col>
        <Col />
      </Row>
    </Container>
  );
};

export default ProfilePage;
